import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import CloseIcon from "@mui/icons-material/Close";
import { CorePropsInterfaces } from "src/core/Models";
import * as Constants from "./../../core/Constants";
import { useContext } from "react";
import { AppContext } from "src/contexts/AppContext";

export default function GtAlertBanner({
  message,
  variant,
  withCloseButton = true,
  alertBannerVisibleUS,
}: CorePropsInterfaces.GtAlertBannerProps): JSX.Element {
  const { dispatch, globalState } = useContext(AppContext);
  let alertVariant = "";
  if (
    !!variant &&
    variant === Constants.GtAlertBannerVariant.GenerateDocuments
  ) {
    alertVariant = "gt-alertBanner--generateDocumentsVariant";
  }
  if (!!variant && variant === Constants.GtAlertBannerVariant.QuestionPage) {
    alertVariant = "gt-alertBanner--questionPageVariant";
  }
  let alertBannerVisible = true;
  if (withCloseButton) {
    alertBannerVisible = alertBannerVisibleUS
      ? globalState.alertBanner.CouselingBanner
      : globalState.alertBanner.ServiceAgreementBanner;
  }

  const handleCloseBanner = () => {
    let counselinBanner = globalState.alertBanner.CouselingBanner;
    let serviceAgreementBanner = globalState.alertBanner.ServiceAgreementBanner;
    if (alertBannerVisibleUS) {
      counselinBanner = !counselinBanner;
    } else {
      serviceAgreementBanner = !serviceAgreementBanner;
    }

    dispatch({
      type: Constants.AppStateActions.UpdateAlertBanner,
      payload: {
        CouselingBanner: counselinBanner,
        ServiceAgreementBanner: serviceAgreementBanner,
      },
    });
  };

  return (
    alertBannerVisible && (
      <article className={`gt-alertBanner ${alertVariant}`}>
        <section className="gt-alertBanner__left">
          <ErrorOutlineRoundedIcon className="gt-alertBanner__left-icon" />
          {message}
        </section>
        {withCloseButton && (
          <section className="gt-alertBanner__right">
            <CloseIcon onClick={handleCloseBanner} />
          </section>
        )}
      </article>
    )
  );
}
